import { Spacer, ThemeToggle } from "@fullscript/aviary-web";
import type { ReactNode } from "react";

import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { useIsPatientDarkModeDisabled } from "@shared/hooks/useIsPatientDarkModeDisabled/useIsPatientDarkModeDisabled";

import { FooterLogos } from "./FooterLogos/FooterLogos";
import { FooterPrivacy } from "./FooterPrivacy/FooterPrivacy";

import * as styles from "./AuthFooter.styles";

interface Props {
  children?: ReactNode;
}

const AuthFooter = ({ children, ...rest }: Props) => {
  const { tablet } = useBreakpoints();
  const isDarkModeDisabled = useIsPatientDarkModeDisabled();

  const renderContent = () => {
    if (tablet.greaterThan) {
      return (
        <>
          <div>
            <FooterLogos />
          </div>
          <div>
            {children}
            <FooterPrivacy />
          </div>
          <div>{!isDarkModeDisabled && <ThemeToggle />}</div>
        </>
      );
    }

    return (
      <div css={styles.mobileWrapper}>
        {children}
        <Spacer size="xlarge" />
        <FooterLogos />
        <Spacer size="large" />
        <FooterPrivacy />
        {!isDarkModeDisabled && <ThemeToggle />}
      </div>
    );
  };

  return (
    <footer css={[styles.footer, tablet.greaterThan && styles.topBorder]} {...rest}>
      <div css={styles.wrapper}>{renderContent()}</div>
    </footer>
  );
};

export { AuthFooter };
